export enum LaptopDimensions {
  Min = 768,
  Max = 1600,
}
export enum Devices {
  Laptop = "laptop",
  Desktop = "desktop",
}
